import { Component, ErrorInfo, ReactNode } from 'react'
import { Box, Button, Typography } from '@mui/material'

interface Props {
    children: ReactNode
}

interface State {
    hasError: boolean
    message: string
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false, message: '' }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, message: error.message || String(error) }
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error('ErrorBoundary capturou erro:', error, info)
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    sx={{
                        height: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '12px',
                        p: '24px',
                        textAlign: 'center',
                    }}
                >
                    <Typography fontSize="20px" fontWeight={600}>
                        Ocurrió un error en la aplicación
                    </Typography>
                    <Typography
                        fontSize="13px"
                        color="text.secondary"
                        sx={{ maxWidth: '480px', wordBreak: 'break-word' }}
                    >
                        {this.state.message}
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => window.location.reload()}
                    >
                        Recargar
                    </Button>
                </Box>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary
